import styled, { css } from "styled-components";

import { windowWidth } from "@styles/global";

interface ContainerProps {
  searchIsActive: boolean;
}

const Container = styled.nav<ContainerProps>`
  background-color: ${(props) => props.theme.colors.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 5px;
  transition: all 0.5s;
  width: 100%;
  color: ${(props) => props.theme.colors.primary};

  @media (max-width: ${windowWidth.webDefault}) {
    border-bottom: 2px solid #e5e5e5;
  }

  .navbar-top > :first-child {
    display: none;
    visibility: hidden;

    @media (max-width: ${windowWidth.webDefault}) {
      display: block;
      visibility: visible;
      cursor: pointer;

      :not(:hover) {
        transition: all 0.2s;
      }

      :hover {
        transition: all 0.5s;
        transform: scale(1.2);
      }
    }
  }

  @media (max-width: ${windowWidth.mobile.large}) {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

interface ProductIconContainer {
  searchIsActive: boolean;
}

const ProductIconContainer = styled.div<ProductIconContainer>`
  width: 200px;

  svg {
    width: 100%;
    height: 100%;
  }
  .version {
    text-align: right;
    font-size: 0.6rem;
  }
  .version-desktop {
    margin-top: -10px;
  }

  @media (max-width: ${windowWidth.tablet}) {
    width: 180px;

    ${({ searchIsActive }) => searchIsActive
      && css`
        display: none;
      `}
  }
`;

const SearchContainer = styled.div``;

interface NavbarTopProps {
  showSelectClient: boolean;
}

const NavbarTop = styled.div<NavbarTopProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 35px;

  @media (max-width: ${windowWidth.tablet}) {
    ${({ showSelectClient }) => !showSelectClient
      && css`
        margin-bottom: 8px;
      `}
  }
`;

const NavbarBottom = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-top: 8px;
`;

export {
  Container,
  ProductIconContainer,
  SearchContainer,
  NavbarTop,
  NavbarBottom
};
